import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data-information-box-type"]
const _hoisted_2 = {
  key: 0,
  class: "w-4 h-6 flex-col justify-center items-start gap-2.5 inline-flex"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex flex-col w-full" }
const _hoisted_5 = {
  key: 0,
  class: "text-racq-dark-grey text-base-bold"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "flex flex-col md:flex-row gap-4 mt-1"
}
const _hoisted_8 = ["href", "role", "onClick", "innerHTML"]
const _hoisted_9 = { class: "pl-4" }
const _hoisted_10 = {
  key: 0,
  class: "w-4 h-6 flex-col justify-center items-start gap-2.5 inline-flex"
}

import { IInformationBox, LinkTypes } from '@/interfaces/forms/information-box.interface';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InformationBox',
  props: {
    type: {},
    title: {},
    description: {},
    links: {},
    hideIcon: { type: Boolean },
    isCircle: { type: Boolean },
    useButtonSlot: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const iconMap = {
  infodark: require('@/assets/icons/information-dark.svg'),
  info: require('@/assets/icons/info-information.svg'),
  warning: require('@/assets/icons/info-warning.svg'),
  error: require('@/assets/icons/info-error.svg'),
  success: require('@/assets/icons/info-success.svg'),
};

const iconCircleMap = {
  info: require('@/assets/icons/info-information.svg'),
  infodark: require('@/assets/icons/info-information.svg'),
  warning: require('@/assets/icons/info-warning-circle.svg'),
  error: require('@/assets/icons/info-error.svg'),
  success: require('@/assets/icons/info-success.svg'),
};

const backgroundColorMap = {
  info: 'bg-racq-info-light-blue',
  infodark: 'bg-racq-anti-flash-white',
  warning: 'bg-racq-info-light-yellow',
  error: 'bg-racq-info-light-red',
  success: 'bg-racq-info-light-green',
};

const icon = computed(() => (props.isCircle ? iconCircleMap[props.type] : iconMap[props.type]));
const backgroundColor = computed(() => backgroundColorMap[props.type]);

function getButtonClasses(link: any) {
  if (!link) return '';

  switch (link.type) {
    case LinkTypes.BUTTON_PRIMARY:
      return 'btn btn-primary btn-sm';

    case LinkTypes.BUTTON_SECONDARY:
      return 'btn btn-secondary btn-sm';
  }
}
function handleButtonClick(link: any) {
  if (typeof link.onClick === 'function') {
    link.onClick();
  } else if (link.url) {
    window.location.href = link.url;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'flex w-full px-6 rounded gap-4',
      backgroundColor.value,
      { 'py-5': !_ctx.useButtonSlot || !_ctx.$slots.buttons, 'pt-5': _ctx.useButtonSlot && _ctx.$slots.buttons },
    ]),
      "data-information-box-type": _ctx.type
    }, [
      (!!icon.value && !_ctx.hideIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createElementVNode("img", {
              src: icon.value,
              alt: `${_ctx.type} icon`,
              class: "w-4 h-4"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.$slots.infoBoxContent && _ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        (!_ctx.$slots.infoBoxContent && _ctx.description)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "text-racq-dark-grey text-m mt-[2px]",
              innerHTML: _ctx.description
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (!_ctx.$slots.infoBoxContent && _ctx.links)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  href: link.url || '#',
                  class: _normalizeClass([getButtonClasses(link), "text-m"]),
                  role: !link.url ? 'button' : undefined,
                  onClick: _withModifiers(($event: any) => (handleButtonClick(link)), ["prevent"]),
                  innerHTML: link.title
                }, null, 10, _hoisted_8))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.$slots.infoBoxContent)
          ? _renderSlot(_ctx.$slots, "infoBoxContent", {
              key: 3,
              class: "flex flex-col w-full"
            }, () => [
              _cache[0] || (_cache[0] = _createTextVNode(" [Named slot for info box content (infoBoxContent)] "))
            ])
          : _createCommentVNode("", true)
      ])
    ], 10, _hoisted_1),
    (_ctx.useButtonSlot && _ctx.$slots.buttons)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['w-full px-6 rounded  pb-5 pl-[3.43rem]', backgroundColor.value])
        }, [
          _renderSlot(_ctx.$slots, "buttons", {}, () => [
            _createElementVNode("div", _hoisted_9, [
              (!!icon.value && !_ctx.hideIcon)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                : _createCommentVNode("", true),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex flex-col w-full" }, null, -1))
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})